module.exports = __webpack_public_path__ + "img/HZ-T1516.d8758a44.jpg";